<template>

  <svg
    t="1639130487569"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4134"
    width="64"
    height="64"
  ><path d="M930.71848999 613.47251562l-70.5385903-21.85452561V296.56413125l-352.58634094-194.02554187-352.62187594 194.02554187v387.69572438l352.62187594 194.02554092 51.27817875-28.25097092 21.03720188 59.59355906-72.31538063 39.16046625L84.46862844 719.65352563V261.06385344L507.59355875 31.96446406l423.12493124 229.09938938v352.40866218z m-423.12493124-96.65741251l458.41199345 167.9777897-229.20599626 65.63464781-55.32926156 233.57690157-173.87673563-467.18933908z" p-id="4135" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconInteract',
} as DefineComponent
</script>